import { render } from "./terms1.vue?vue&type=template&id=3ef441aa&scoped=true"
const script = {}

import "./terms1.vue?vue&type=style&index=0&id=3ef441aa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef441aa"]])

export default __exports__